const scrapingIssueCommentFormInitialValues = ({
  id,
  scrapingIssueComment,
}) => ({
  id,
  scrapingIssueComment,
})

export default scrapingIssueCommentFormInitialValues
